import React from 'react';
import styles from './my-downloads-head.module.scss';
import UTEClientViewWrapper from 'src/components/ute-client-view-wrapper';
import UTEButton from 'src/components/ute-button';

type MyDownloadsHeadProps = {
	onClearAll: () => void;
	showClearAllBtn: boolean;
};

const MyDownloadsHead = ({ onClearAll, showClearAllBtn }: MyDownloadsHeadProps) => {
	return (
		<section className={styles.mydownloadsHeadContainer}>
			<div className={styles.headActionsContainer}>
				<div className={styles.leftActions}>
					<div>
						<h2 className='pageModuleHeader'>My Downloads</h2>
					</div>
					<div>
						<p className='pageModuleDescription'>Multiple file downloads will appear on this page </p>
					</div>
				</div>
				<div className={styles.rightActions}>
					{showClearAllBtn && (
						<UTEClientViewWrapper dataTestAuto='4325A227-2934-49A5-9A41-F6A7A16CE4EF'>
							<UTEButton
								className={styles.btnClearAll}
								dataTestAuto='313751CB-0517-4089-B767-9CCCB249F3B4'
								text='Clear All'
								onClick={() => {
									onClearAll();
								}}
								disabled={false}
								title='Clear All'
							/>
						</UTEClientViewWrapper>
					)}
				</div>
			</div>
		</section>
	);
};

export default MyDownloadsHead;
